import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import CircularProgress from "@mui/material/CircularProgress";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { styled as materialStyles } from "@mui/material/styles";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import info from "../../../assets/icon.png";
import Checkbox from "@mui/material/Checkbox";
import { useForm } from "react-hook-form";
import { message } from "antd";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useDispatch } from "react-redux";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import LoadingButton from "@mui/lab/LoadingButton";
import FormGroup from "@mui/material/FormGroup";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import SearchIcon from "@mui/icons-material/Search";
import InfoIcon from "@mui/icons-material/Info";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

import {
  vendorRegistrationUpdate,
  hsnCategories,
  hsnValues,
  getVendorDetails,
  itemValues,
  validateMSMENumber,
} from "../redux/vendorRegistrationSlice";
import {
  UserInfoDiv,
  VendorCardTitle,
  VendorInstructions,
  VendorListHolder,
} from "./steps/vendorRegEdit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styled from "styled-components";
import BankRegEdit from "./steps/bankRegEdit";
import BankReg from "./steps/bankReg";
import BankDetailsManager from "./steps/BankDetailsManager";
import { useSelector } from "react-redux";
import { BankDisabledFields, Super } from "./steps/cardTrialEdit";
import FormHelperText from "@mui/material/FormHelperText";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
/* import ArrowRightIcon from "@mui/icons-material/ArrowRight"; */
import _without from "lodash/without";
import _ from "lodash";
import LocalStorage from "../../../utilities/localStorage";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useParams } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  concernTypeForJaslok,
  CustomFormControl,
  CustomFormSelection,
} from "./StepMain";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from "@mui/material";
import { Clear, Edit, FileDownload } from "@mui/icons-material";
import { VendorCardBlankTitle } from "./steps/cardTrial";
import VRF_vishakha from "../../../assets/F-PUR-03-VRF-Vishakha.DOCX";
import MsmeComponents from "../../../common/sharedComponents/styles/msmeComponents";
import { CustomDocumentLink } from "../../../common/sharedComponents/styles/card.style";
const steps = ["Vendor Details", "Business Details", "Bank Details"];
const Input = materialStyles("input")({
  display: "none",
});
export const radioStyles = {
  selectRadio: {
    border: "1px solid #D9D8FF",
    padding: "0px 7px 0px 7px",
    background: "#D9D8FF",
    borderRadius: "4px",
    marginLeft: "-6px",
  },
};

export const radioStyles1 = {
  selectRadio: {
    border: "1px solid #D9D8FF",
    padding: "0px 7px 0px 7px",
    background: "#D9D8FF",
    borderRadius: "4px",
    marginLeft: "-6px",
    marginRight: "15px",
  },
};
export default function StepMainEdit() {
  const vendorCompany = JSON.parse(localStorage.getItem("client"));
  const value = JSON.parse(localStorage.getItem("tata_login_user"));
  const { categories, subcategories, vendor_details, itemcategories } =
    useSelector((state) => state.vendorRegistration);
  const { msmeLoading } = useSelector((state) => state.vendorRegistration);

  const [userdata, setUserdata] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [checkedPan, setCheckedPan] = useState(false);
  const [checkedMSME, setCheckedMSME] = useState(false);
  const [panDoc, setPanDoc] = useState("");
  const [dealer, setDealer] = useState("");
  const [tin, setTin] = useState("");
  const [iso, setIso] = useState("");
  const [msmeDoc, setmsmeDoc] = useState("");
  const [checkedType, setCheckedType] = useState("");
  const [subCategory, setSubCategory] = useState("");

  const [anyDocs, setAnyDocs] = useState([]);
  const [userinfo, setUserInfo] = useState({
    codes: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isDetailsLoading, setIsDetailsLoading] = useState(true);
  const [isLoadingsub, setIsLoadingsub] = useState(false);
  const [search, setSearch] = useState("");
  const [searchsub, setSearchsub] = useState("");
  const [catdisplay, setCatdisplay] = useState("none");
  const [subcatdisplay, setSubcatdisplay] = useState("none");

  const [itemcodes, setItemcodes] = useState("");
  const [isLoadingitem, setIsLoadingitem] = useState(false);
  const [searchitem, setSearchitem] = useState("");
  const [itemcatdisplay, setItemcatdisplay] = useState("none");
  const [mSME, setMSME] = useState("");
  const [msmenum, setMsmenum] = useState("");
  const [annualCr, setAnnualCr] = useState("₹0.00 CR");
  const [editMSMEDailog, setEditMSMEDailog] = useState(false);
  const [editMSMEDoc, setEditMSMEDoc] = useState("");
  const [editMSMENumber, setEditMSMENumber] = useState(null);
  const [validatedMsmeData, setValidatedMsmeData] = useState(null);
  const [msmeMismatch, setMsmeMismatch] = useState(null);
  const [isApproved, setIsApproved] = useState(false);
  const [isCompanyNameEditable, setIsCompanyNameEditable] = useState(true);
  const [companyName, setCompanyName] = useState("");
  const [legalName, setLegalName] = useState("");
  const isEditable = isCompanyNameEditable && !vendor_details?.vendor_code && !vendor_details?.is_approved;
  const convertToMillions = (e) => {
    let num;

    if (e.target) {
      num = e.target.value;
    } else {
      num = e;
    }
    if (num === undefined) return "";
    const millions = num / 10;

    const ready =
      millions.toLocaleString("en-IN", { style: "currency", currency: "INR" }) +
      " CR";
    setAnnualCr(ready);
  };
  const EditMSMEHandle = () => {
    setEditMSMEDailog(true);
    setMsmeMismatch(null);
  };
  const msmeEditCancleHandle = () => {
    setEditMSMENumber(null);
    setEditMSMEDoc("");
    setEditMSMEDailog(false);
    setMsmeMismatch(null);
  };

  const validateMsme = () => {
    if (!msmenum) {
      return message.info("Please enter MSME Registration Number");
    }
    dispatch(
      validateMSMENumber({
        msme: msmenum,
        company_constitution: userdata?.company_constitution || "",
        legal_name: value?.legal_name || "",
        user_id: value?.user_id || value?.id || undefined,
      })
    ).then((response) => {
      const { success, data, message: msg } = response.payload;
      if (
        success &&
        data?.[0]?.status === "completed" &&
        data?.[0]?.result?.source_output?.status === "id_found"
      ) {
        setCheckedMSME(true);
        setMsmeMismatch(null);
        const generalDetails = data[0]?.result?.source_output?.general_details;
        const enterpriseTypeData =
          data[0]?.result?.source_output?.enterprise_type?.[0]?.enterprise_type_1;
        setValidatedMsmeData({
          msme_registration_number: msmenum || "",
          msme_type: generalDetails?.enterprise_type || "",
          enterprise_name: generalDetails?.enterprise_name || "",
          enterprise_activity: generalDetails?.major_activity || "",
          classification_date: enterpriseTypeData?.classification_date || "",
          classification_year: enterpriseTypeData?.classification_year || "",
        });
        // if (vendor_id) {
        //   ViewVendordetails(vendor_id);
        // }
      } else {
        setCheckedMSME(false);
        if (!success && msg === "Company name Mismatch between MSME Certificate & PAN Card.") {
          const enterpriseName = data?.[0]?.result?.source_output?.general_details?.enterprise_name || "";
          setMsmeMismatch({
            legalName: value?.legal_name || "",
            enterpriseName: enterpriseName,
          });
        } else {
          setMsmeMismatch(null);
        }
      }
    });
  };
  const params = useParams();
  const vendor_id = params.id;

  const dispatch = useDispatch();
  const onSubmit = (payload) => {
    setLoading(true);
    payload["vendor_id"] = vendor_id;
    dispatch(vendorRegistrationUpdate(payload)).then((response) => {
      if (response?.payload?.success) {
        setLoading(false);
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
          newSkipped = new Set(newSkipped.values());
          newSkipped.delete(activeStep);
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
        ViewVendordetails(vendor_id);
      } else {
        setLoading(false);
      }
    });
  };
  const ViewVendordetails = async (vendor_id) => {
    setIsDetailsLoading(true);
    await dispatch(getVendorDetails(vendor_id)).then((response) => {
      setIsDetailsLoading(false);
      if (response?.payload?.success) {
        // setUserdata(response?.payload?.data);
        const loadedData = {
          company_name: response?.payload?.data?.company_name || response?.payload?.data?.User?.company_name || "",
          legel_name: response?.payload?.data?.legal_name || response?.payload?.data?.User?.legal_name || "",
          company_constitution:
            response?.payload?.data?.company_constitution &&
              response.payload.data.company_constitution.toLowerCase() === "body of individuals"
              ? "Body of Individuals"
              : vendorCompany?.id === 5
                ? _.startCase(
                  _.toLower(response?.payload?.data.company_constitution)
                )
                : response?.payload?.data.company_constitution,
          company_nature: response?.payload?.data.company_nature,
          affirmative_action_category:
            response?.payload?.data.affirmative_action_category,
          business_interest_areas:
            response?.payload?.data.business_interest_areas,
          registration_type: response?.payload?.data.gst_registration_type,
          tax_identification_number:
            response?.payload?.data.tax_identification_number,
          annual_turnover: response?.payload?.data.annual_turnover
            ? response?.payload?.data.annual_turnover
            : "",
          ind_annual_turnover: response?.payload?.data.annual_turnover
            ? convertToMillions(response?.payload?.data.annual_turnover)
            : "",
          msme_register: response?.payload?.data?.Msme
            ? response?.payload?.data?.Msme?.msme_type === "others"
              ? "others"
              : "Applicable"
            : "others",

          msme_registration_number: response?.payload?.data?.Msme
            ? response?.payload?.data.Msme.registration_number
            : "",
          classification_date: response?.payload?.data?.Msme
            ? response?.payload?.data.Msme.classification_date
            : "",
          classification_year: response?.payload?.data?.Msme
            ? response?.payload?.data.Msme.classification_year
            : "",
          enterprise_activity: response?.payload?.data?.Msme
            ? response?.payload?.data.Msme.enterprise_activity
            : "",
          enterprise_name: response?.payload?.data?.Msme
            ? response?.payload?.data.Msme.enterprise_name
            : "",
          msme_type: response?.payload?.data?.Msme
            ? response?.payload?.data.Msme.msme_type
            : "",
          msme_doc: response?.payload?.data.Documents[0]
            ? response?.payload?.data.Documents[0].msme_certificate_image
            : "",
        };

        setUserdata(loadedData);
        setMSME(
          response?.payload?.data?.Msme
            ? response?.payload?.data?.Msme?.msme_type === "others"
              ? "others"
              : "Applicable"
            : "others"
        );
        reset(loadedData);

        setIsCompanyNameEditable(response?.payload?.data?.isCompanyNameEditable ?? true);
        setCompanyName(loadedData.company_name);
        setLegalName(loadedData.legel_name);

        setIsApproved(
          !!response?.payload?.data?.is_fully_approved ||
          !!response?.payload?.data?.is_approved ||
          !!response?.payload?.data?.vendor_code
        );

        if (response?.payload?.data?.Documents?.[0]?.pan_image_name) {
          setPanDoc({
            name: response?.payload?.data?.Documents
              ? response?.payload?.data?.Documents?.[0]?.pan_image_name
              : "",
          });
        }
        if (
          response?.payload?.data?.Documents?.[0]
            ?.supporting_document_image_name
        ) {
          const fileName =
            response?.payload?.data?.Documents?.[0]
              ?.supporting_document_image_name;
          const filePath =
            response?.payload?.data?.Documents?.[0]?.supporting_document_image;
          const concatResource = fileName.map(function (fileName, index) {
            return { name: fileName, path: filePath[index] };
          });
          setAnyDocs(concatResource);
          setNewDocs(concatResource.length > 0 ? concatResource : [0]);
        }

        if (response?.payload?.data?.Documents?.[0]?.msme_certificate_image) {
          setmsmeDoc({
            name: response?.payload?.data?.Documents
              ? response?.payload?.data?.Documents?.[0]
                ?.msme_certificate_image_name
              : "",
          });
        }
        if (
          response?.payload?.data?.Documents?.[0]
            ?.dealer_authorization_image_name
        ) {
          setDealer({
            name: response?.payload?.data?.Documents
              ? response?.payload?.data?.Documents?.[0]
                .dealer_authorization_image_name
              : "",
          });
        }
        if (
          response?.payload?.data?.Documents?.[0]?.tin_certificate_image_name
        ) {
          setTin({
            name: response?.payload?.data?.Documents
              ? response?.payload?.data?.Documents?.[0]
                .tin_certificate_image_name
              : "",
          });
        }
        if (
          response?.payload?.data?.Documents?.[0]?.iso_or_rsdo_or_any_image_name
        ) {
          setIso({
            name: response?.payload?.data?.Documents
              ? response?.payload?.data?.Documents?.[0]
                .iso_or_rsdo_or_any_image_name
              : "",
          });
        }
        if (response?.payload?.data?.hsn_codes?.length) {
          let hsn_codes = response?.payload?.data?.hsn_codes;
          setUserInfo({
            codes: hsn_codes,
          });
        }
        setCheckedPan(response?.payload?.data?.pan_confirmation);
        if (response?.payload?.data?.Msme?.registration_number) {
          setCheckedMSME(true);
        }
      }
    }).catch(() => {
      setIsDetailsLoading(false);
    });
  };
  useEffect(() => {
    ViewVendordetails(vendor_id);
    // eslint-disable-next-line
  }, []);

  const getCategories = (payload) => {
    dispatch(hsnCategories(payload)).then((response) => {
      if (response.payload.success === true) {
        setIsLoading(false);
      }
    });
  };

  const getHSNCodes = (payload) => {
    dispatch(hsnValues(payload)).then((response) => {
      if (response.payload.success === true) {
        setIsLoadingsub(false);
      }
    });
  };

  const getItemsCodes = (payload) => {
    dispatch(itemValues(payload)).then((response) => {
      if (response.payload.success === true) {
        setIsLoadingitem(false);
      }
    });
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };
  const [newDocs, setNewDocs] = useState([anyDocs.length]);
  const handleOnClick = () => {
    let docsCopy = [...newDocs];

    docsCopy.push({
      any_docs: "",
    });

    setNewDocs(docsCopy);
  };

  const handlechangeDoc = (e, index) => {
    let newDocValues = [...anyDocs];
    newDocValues[index] = e.target.files[0];
    setAnyDocs(newDocValues);
  };

  const handleRemove = (e, i) => {
    let uploadeddocs = [...newDocs];
    uploadeddocs.splice(i, 1);
    setNewDocs(uploadeddocs);

    let currentAnyDocs = [...anyDocs];
    currentAnyDocs.splice(i, 1);
    setAnyDocs(currentAnyDocs);
  };

  const handleclearDoc = (e, index) => {
    let newDocValues = [...anyDocs];
    newDocValues[index] = "";
    setAnyDocs(newDocValues);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    watch,
    reset,
    setValue,
  } = useForm();
  const watchAllFields = watch();
  const watchedConstitution = watch("company_constitution");

  const handleNext = (data) => {
    const initialConstitution =
      vendor_details?.company_constitution || userdata?.company_constitution || "";
    const isConstitutionChanged =
      Boolean(watchedConstitution) &&
      Boolean(initialConstitution) &&
      watchedConstitution !== initialConstitution;

    const isMsmeApplicable =
      mSME === "Applicable" || (mSME !== "others" && mSME !== "");

    const isMsmeValidationRequired =
      is_domestic &&
      (isMsmeApplicable || (isMsmeApplicable && isConstitutionChanged));

    if (activeStep === 0 && isMsmeValidationRequired && !checkedMSME) {
      return message.error(
        "Please validate your MSME registration number before proceeding."
      );
    }
    var formData = new FormData();
    for (let i = 0; i < newDocs.length; i++) {
      formData.append("supporting_document_image", anyDocs[i]);
    }

    const supportingDocsInfo = anyDocs.map((doc) => {
      if (doc && doc.path) {
        return { name: doc.name, path: doc.path };
      } else if (doc instanceof File) {
        return { name: doc.name, isNew: true };
      } else {
        return null;
      }
    }).filter(Boolean);
    data.supporting_docs_info = supportingDocsInfo;

    if (validatedMsmeData) {
      data.msme_type = validatedMsmeData.msme_type;
      data.classification_date = validatedMsmeData.classification_date;
      data.classification_year = validatedMsmeData.classification_year;
      data.enterprise_activity = validatedMsmeData.enterprise_activity;
      data.enterprise_name = validatedMsmeData.enterprise_name;
      data.msme_registration_number = validatedMsmeData.msme_registration_number;
    }

    formData.append("data", JSON.stringify(data));
    formData.append("pan_image", panDoc);
    formData.append("msme_certificate_image", msmeDoc);
    formData.append("msme_certificate_image_edit", editMSMEDoc);
    formData.append("dealer_authorization_image", dealer);
    formData.append("tin_certificate_image", tin);
    formData.append("iso_or_rsdo_or_any_image", iso);
    formData.append("codes", JSON.stringify(userinfo.codes));
    formData.append("pan_declaration", checkedPan);
    formData.append("vendor_id", vendor_id);
    formData.append("msme_number_edit", editMSMENumber);

    onSubmit(formData);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setCheckedPan(false);
  };
  const handleReset = () => {
    setActiveStep(0);
  };

  const handleChange = (event) => {
    if (event.target.checked) {
      setCheckedPan(true);
    } else {
      setCheckedPan(false);
    }
  };
  const [loading, setLoading] = useState(false);

  const handleadditionalChange = (e, type) => {
    setCheckedType(type);
    // eslint-disable-next-line
    getCategories(type == 2 ? "HSN" : "SAC");
    setIsLoading(true);
    setSearch("");
    setCatdisplay("block");
    setItemcatdisplay("none");
    setSubcatdisplay("none");
  };
  const initialSelected = [];
  const [personName, setPersonName] = useState(initialSelected);
  const handlecategoryChange = (e, type) => {
    setSubCategory(type);
    getHSNCodes(type);
    setIsLoadingsub(true);
    setSearchsub("");
    setSubcatdisplay("block");
    setItemcatdisplay("none");
  };

  const handlesubcategoryChange = (e, type) => {
    setItemcodes(type);
    getItemsCodes(type);
    setIsLoadingitem(true);
    setSearchitem("");
    setItemcatdisplay("block");
  };

  const handleDelete = (chipToDelete) => () => {
    let codes = userinfo.codes;

    let filtered = codes.filter((codes) =>
      codes.toLowerCase().includes(chipToDelete.toLowerCase())
    );
    const array1 = codes.filter((val) => !filtered.includes(val));
    setUserInfo({
      codes: array1,
    });
    setPersonName((current) => _without(current, chipToDelete));
    // setUserInfo({})
  };

  const handleCheckChange = (e, type) => {
    const { checked } = e.target;
    const { codes } = userinfo;
    if (checked) {
      setUserInfo({
        codes: [...codes, type],
      });
      setPersonName([...personName, type]);
    }
  };

  const handleregistrationChange = (e) => {
    setUserdata({
      ...userdata,
      registration_type: e.target.value,
    });
    setValue("registration_type", e.target.value, { shouldValidate: true });
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const code_filtered = !search
    ? categories
    : categories.filter((categories) =>
      categories.categortDescription
        .toLowerCase()
        .includes(search.toLowerCase())
    );

  const sub_filtered = !searchsub
    ? subcategories
    : subcategories.filter((subcategories) =>
      subcategories.subCategory
        .toLowerCase()
        .includes(searchsub.toLowerCase())
    );

  const item_filtered = !searchitem
    ? itemcategories
    : itemcategories.filter((itemcategories) =>
      itemcategories.item.toLowerCase().includes(searchitem.toLowerCase())
    );

  const onChange = (e) => {
    const { name, value } = e.target;
    setUserdata({ ...userdata, [name]: value });
    setValue(name, value, { shouldValidate: true });
    if (name === "company_constitution") {
      setCheckedMSME(false);
      setMsmeMismatch(null);
    }
    if (name === "annual_turnover") {
      convertToMillions(e);
    }
    if (name === "msme_register") {
      setUserdata({
        ...userdata,
        msme_registration_number: "",
        expiry_date: "",
        msme_register: value,
      });
    }
  };

  const handlemsme = (value) => {
    setMSME(value);
    setMsmenum("");
    setValue("msme_register", value, { shouldValidate: true });
    setMsmeMismatch(null);
  };
  var user = LocalStorage.getItem("tata_login_user");

  const is_domestic = user.is_domestic;

  const card = (
    <CardContent>
      <Typography gutterBottom variant="h6" component="div">
        <VendorInstructions>
          <img src={info} alt="info" /> Instructions
        </VendorInstructions>
      </Typography>
      <br />

      <VendorListHolder>
        <li>
          Enter statutory information which includes company nature,
          constitution and GST registration type.
        </li>
        <li>
          Legal name is auto-populated as per the information on the PAN
          database. It is not editable for vendors.
        </li>
        <li>
          Enter all the mandatory fields before proceeding to enter location
          information.
        </li>
        <li className="text-danger">Documents size cannot exceed 500kb</li>
      </VendorListHolder>
    </CardContent>
  );

  const statutory_information = (
    <CardContent>
      <Container fixed>
        <Grid>
          <VendorCardTitle>Statutory information</VendorCardTitle>
          <UserInfoDiv>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <VendorCardLabel>Company name {isEditable && <Super>*</Super>}</VendorCardLabel>
                {isEditable ? (
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    InputProps={{
                      disableUnderline: false,
                      disableInjectingGlobalStyles: true,
                    }}
                    placeholder="Enter company name"
                    size="small"
                    variant="standard"
                    style={{ width: "100%", paddingTop: "3px" }}
                    name="company_name"
                    {...register("company_name", {
                      required: "Please enter company name",
                      value: companyName,
                    })}
                    value={companyName}
                    onChange={(e) => {
                      setCompanyName(e.target.value);
                      setValue("company_name", e.target.value, { shouldValidate: true });
                    }}
                    error={Boolean(errors?.company_name)}
                    helperText={errors.company_name?.message}
                  />
                ) : (
                  <VendorDisabledFields>
                    {companyName || value.company_name}
                  </VendorDisabledFields>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <VendorCardLabel>Company email</VendorCardLabel>

                <VendorDisabledFields>
                  {value.contact_person_email}
                </VendorDisabledFields>
              </Grid>
              <Grid item xs={12} md={4}>
                <VendorCardLabel>
                  Permanent account number (PAN)
                </VendorCardLabel>

                <VendorDisabledFields>
                  {typeof value.PAN_number !== undefined &&
                    value.legal_name !== null
                    ? `${value.PAN_number}`
                    : `International`}
                </VendorDisabledFields>
              </Grid>
            </Grid>
          </UserInfoDiv>
        </Grid>
        <br />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <VendorCardLabel>
              Legal name <Super>*</Super>
            </VendorCardLabel>

            <VendorDisabledFields
              {...register("legel_name", {
                value: value.legal_name,
              })}
              style={{
                borderBottom: "1px solid lightgray",
                width: "100%",
                padding: " 0 0 5px 0",
                paddingTop: "5px",
              }}
            >
              {typeof value.legal_name !== undefined &&
                value.legal_name !== null
                ? `${value.legal_name}`
                : `Not Applicable`}
            </VendorDisabledFields>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              variant="standard"
              style={{ width: "100%" }}
              error={Boolean(errors?.company_constitution)}
            >
              <VendorCardLabel>
                Company constitution <Super>*</Super>
              </VendorCardLabel>
              <Select
                sx={{ fontFamily: "var(--font-family-reg)", fontSize: "14px" }}
                displayEmpty
                defaultValue=""
                IconComponent={() => (
                  <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                )}
                labelId="demo-simple-select-standard-label"
                id="company_constitution"
                label="Company consistution (As per GST certificate)"
                name="company_constitution"
                {...register("company_constitution", {
                  required: "Please select constitution",
                  value: `${userdata.company_constitution || ""}`,
                })}
                value={userdata.company_constitution || ""}
                onChange={(e) => onChange(e)}
              >
                <MenuItem value="">
                  <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                    Select constitution
                  </span>
                </MenuItem>
                {vendorCompany?.id === 5 ? (
                  concernTypeForJaslok.map((item) => (
                    <MenuItem key={item.concernTypeId} value={item.concernType}>
                      <span>{item.concernType}</span>
                    </MenuItem>
                  ))
                ) : (
                  <>
                    <MenuItem value="Association of Persons (AOP)">
                      <SelectSpan>Association of Persons (AOP)</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Body of Individuals">
                      <SelectSpan>Body of Individuals</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Partnership Firm">
                      <SelectSpan>Partnership Firm</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Individual/One person Company">
                      <SelectSpan>Individual/One person Company</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Individual">
                      <SelectSpan>Individual</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Joint Venture (JV)">
                      <SelectSpan>Joint Venture (JV)</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Limited Liability Partnership (LLP)">
                      <SelectSpan>
                        Limited Liability Partnership (LLP)
                      </SelectSpan>
                    </MenuItem>
                    <MenuItem value="Limited">
                      <SelectSpan>Limited</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Limited Company/Listed company">
                      <SelectSpan>Limited Company/Listed company</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Non banking finance company/ Banking company">
                      <SelectSpan>
                        Non banking finance company/ Banking company
                      </SelectSpan>
                    </MenuItem>
                    <MenuItem value="Proprietary Firm">
                      <SelectSpan>Proprietary Firm</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Private Limited Company">
                      <SelectSpan>Private Limited Company</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Firm">
                      <SelectSpan>Firm</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Private Limited">
                      <SelectSpan>Private Limited</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Co-operative society">
                      <SelectSpan>Co-operative society</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Foreign Company">
                      <SelectSpan>Foreign Company</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Hindu Undivided Family">
                      <SelectSpan>Hindu Undivided Family</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Government Organisation">
                      <SelectSpan>Government Organisation</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Government Company">
                      <SelectSpan>Government Company</SelectSpan>
                    </MenuItem>
                  </>
                )}
              </Select>
              <FormHelperText>
                {errors.company_constitution?.message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              variant="standard"
              style={{ width: "100%" }}
              error={Boolean(errors?.company_nature)}
            >
              <VendorCardLabel>
                Company nature<Super> *</Super>
              </VendorCardLabel>
              <Select
                sx={{ fontFamily: "var(--font-family-reg)", fontSize: "14px" }}
                displayEmpty
                defaultValue=""
                IconComponent={() => (
                  <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                )}
                labelId="demo-simple-select-standard-label"
                id="company_nature"
                label="company_nature"
                name="company_nature"
                {...register("company_nature", {
                  required: "Please select company nature",
                  value: `${userdata.company_nature || ""}`,
                })}
                value={userdata.company_nature || ""}
                onChange={(e) => onChange(e)}
              >
                <MenuItem value="">
                  <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                    Select company nature
                  </span>
                </MenuItem>

                <MenuItem value="dta">
                  <SelectSpan>Domestic Tariff Area (DTA)</SelectSpan>
                </MenuItem>
                <MenuItem value="domestic">
                  <SelectSpan> Indian Company</SelectSpan>
                </MenuItem>
                <MenuItem value="Foreign Company">
                  <SelectSpan>Foreign Company (Outside India)</SelectSpan>
                </MenuItem>
                <MenuItem value="sez">
                  <SelectSpan>Special Economic Zone (SEZ)</SelectSpan>
                </MenuItem>
                <MenuItem value="stpi">
                  <SelectSpan>
                    Software Technology Parks of India (STPI)
                  </SelectSpan>
                </MenuItem>
              </Select>
              <FormHelperText>{errors.company_nature?.message}</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              variant="standard"
              style={{ width: "100%" }}
              error={Boolean(errors?.affirmative_action_category)}
            >
              <VendorCardLabel>Affirmative action category</VendorCardLabel>
              <Select
                sx={{ fontFamily: "var(--font-family-reg)", fontSize: "14px" }}
                displayEmpty
                defaultValue=""
                IconComponent={() => (
                  <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                )}
                labelId="demo-simple-select-standard-label"
                id="affirmative_action_category"
                label="Affirmative action category"
                name="affirmative_action_category"
                {...register("affirmative_action_category", {
                  required: false,
                  value: `${userdata.affirmative_action_category}`,
                })}
                error={Boolean(errors?.affirmative_action_category)}
                value={userdata.affirmative_action_category || ""}
                onChange={(e) => onChange(e)}
              >
                <MenuItem value="">
                  <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                    Select category
                  </span>
                </MenuItem>
                <MenuItem value="open">
                  <SelectSpan>OPEN</SelectSpan>
                </MenuItem>
                <MenuItem value="obc">
                  <SelectSpan>OBC</SelectSpan>
                </MenuItem>
                <MenuItem value="sc">
                  <SelectSpan>SC/ST</SelectSpan>
                </MenuItem>
                <MenuItem value="other">
                  <SelectSpan>OTHERS</SelectSpan>
                </MenuItem>
                <MenuItem value="dnd">
                  <SelectSpan>Don't wish to declare</SelectSpan>
                </MenuItem>
              </Select>
              <FormHelperText>
                {errors.affirmative_action_category?.message}
              </FormHelperText>
            </FormControl>
          </Grid>
          {is_domestic && (
            <Grid item xs={12} sm={6} md={4}>
              <FormControl
                variant="standard"
                style={{ width: "100%" }}
                error={Boolean(errors?.registration_type)}
              >
                <VendorCardLabel>
                  Registration type (GST) <Super>*</Super>
                </VendorCardLabel>
                <Select
                  sx={{
                    fontFamily: "var(--font-family-reg)",
                    fontSize: "14px",
                  }}
                  defaultValue=""
                  displayEmpty={true}
                  IconComponent={() => (
                    <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                  )}
                  labelId="demo-simple-select-standard-label"
                  id="registration_type"
                  label="Registration_type"
                  name="registration_type"
                  {...register("registration_type", {
                    required: "Please select registration type",
                    value: `${userdata.registration_type
                      ? userdata.registration_type
                      : userdata.gst_registration_type
                      }`,
                  })}
                  error={Boolean(errors?.registration_type)}
                  value={
                    userdata.registration_type
                      ? userdata.registration_type
                      : userdata.gst_registration_type || ""
                  }
                  onChange={(e) => onChange(e)}
                >
                  <MenuItem value="">
                    <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                      Select registration type
                    </span>
                  </MenuItem>
                  <MenuItem value="regular">
                    <SelectSpan>Regular</SelectSpan>
                  </MenuItem>
                  <MenuItem value="composition">
                    <SelectSpan>Composition</SelectSpan>
                  </MenuItem>
                  {userdata?.registration_type === "unregistered" ? (
                    <MenuItem value="unregistered">
                      <SelectSpan>Not Applicable</SelectSpan>
                    </MenuItem>
                  ) : (
                    ""
                  )}
                </Select>
                <FormHelperText>
                  {errors.registration_type?.message}
                </FormHelperText>
              </FormControl>
            </Grid>
          )}

          <Grid item xs={12} sm={6} md={4}>
            <VendorCardLabel>Tax Identification number (TIN)</VendorCardLabel>
            <TextField
              sx={{
                input: {
                  fontSize: "14px",
                  fontFamily: "var(--font-family-reg)",
                },
              }}
              InputProps={{
                disableUnderline: false,
                disableInjectingGlobalStyles: true,
              }}
              InputLabelProps={{
                disableAnimation: true,
                disableInjectingGlobalStyles: true,
              }}
              placeholder="Do not enter GSTIN here"
              size="small"
              variant="standard"
              style={{ width: "100%", paddingTop: "3px" }}
              name="tax_identification_number"
              {...register("tax_identification_number", {
                required: false,
                value: `${userdata.tax_identification_number}`,
              })}
              value={userdata.tax_identification_number || ""}
              onChange={(e) => onChange(e)}
            />
          </Grid>
          {/* </Grid>
        <br />
        <Grid container spacing={3}> */}
          <Grid item xs={12} sm={6} md={4}>
            <VendorCardLabel>Annual turnover (in millions)</VendorCardLabel>
            <TextField
              sx={{
                input: {
                  fontSize: "14px",
                  fontFamily: "var(--font-family-reg)",
                },
              }}
              InputProps={{
                disableUnderline: false,
                disableInjectingGlobalStyles: true,
              }}
              InputLabelProps={{
                disableAnimation: true,
                disableInjectingGlobalStyles: true,
              }}
              size="small"
              variant="standard"
              style={{
                width: "100%",
                paddingTop: "3px",
                borderBottom: "1px solid lightgray",
              }}
              name="annual_turnover"
              placeholder="Enter annual turnover"
              {...register("annual_turnover", {
                required: false,
                pattern: {
                  value: /^-?\d*(\.\d{1,2})?$/,
                  message: "Invalid number format",
                },
                value: userdata.annual_turnover,
              })}
              value={userdata.annual_turnover || ""}
              error={errors?.annual_turnover}
              helperText={errors.annual_turnover?.message}
              onChange={async (e) => {
                onChange(e);
                await trigger("annual_turnover");
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <VendorCardLabel>Annual turnover (in Crores)</VendorCardLabel>
            <VendorDisabledFields>{annualCr}</VendorDisabledFields>
          </Grid>
        </Grid>
      </Container>
    </CardContent>
  );

  const msme_information = (
    <CardContent>
      <Container fixed>
        <VendorCardTitle>
          <Grid container justifyContent={"space-between"}>
            <Grid item>MSME information</Grid>
            {userdata.msme_register !== "others" && (
              <Grid
                item
                justifyContent={"end"}
                onClick={EditMSMEHandle}
                sx={{
                  cursor: "pointer",
                }}
              >
                <Tooltip title="Edit MSME Details">
                  <Edit color="info" fontSize="small" />
                </Tooltip>
              </Grid>
            )}
          </Grid>
        </VendorCardTitle>
        <VRSubTitle>For tax purposes</VRSubTitle>
        <Grid container spacing={1}>
          {is_domestic && (
            <Grid item xs={12} md={4}>
              <FormControl
                variant="standard"
                style={{ width: "100%" }}
                error={Boolean(errors?.msme_register)}
              >
                <VendorCardLabel>
                  Are you MSME registered? <Super>*</Super>
                </VendorCardLabel>
                {userdata.msme_register !== "others" ? (
                  <BankDisabledFields>Applicable</BankDisabledFields>
                ) : (
                  <Select
                    sx={{
                      fontFamily: "var(--font-family-reg)",
                      fontSize: "14px",
                    }}
                    defaultValue=""
                    displayEmpty={true}
                    IconComponent={() => (
                      <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                    )}
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    label="Are you MSME registered?"
                    defaultChecked={userdata.msme_register}
                    name="msme_register"
                    {...register("msme_register", {
                      required: "Please select MSME category",
                      value: userdata.msme_register,
                    })}
                    onChange={(e) => handlemsme(e.target.value)}
                  >
                    <MenuItem value="">
                      <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                        Select value
                      </span>
                    </MenuItem>
                    <MenuItem value="Applicable">
                      <SelectSpan>Applicable</SelectSpan>
                    </MenuItem>
                    <MenuItem value="others">
                      <SelectSpan>Not Applicable</SelectSpan>
                    </MenuItem>
                  </Select>
                )}

                <FormHelperText>{errors.msme_register?.message}</FormHelperText>
              </FormControl>
            </Grid>
          )}

          {userdata.msme_register !== "others" ||
            (mSME !== "others" && mSME !== "") ? (
            <>
              <Grid item xs={12} md={4}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <VendorCardLabel>
                    MSME registration number <Super>*</Super>
                  </VendorCardLabel>
                  {userdata.msme_register !== "others" &&
                    userdata.msme_registration_number !== "" ? (
                    <BankDisabledFields>
                      {validatedMsmeData
                        ? validatedMsmeData.msme_registration_number
                        : userdata.msme_registration_number}
                    </BankDisabledFields>
                  ) : (
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      InputProps={{
                        disableUnderline: false,
                        disableInjectingGlobalStyles: true,
                      }}
                      InputLabelProps={{
                        disableAnimation: true,
                        disableInjectingGlobalStyles: true,
                      }}
                      size="small"
                      variant="standard"
                      style={{
                        width: "100%",
                        paddingTop: "3px",
                        borderBottom: "1px solid lightgray",
                      }}
                      name="msme_registration_number"
                      placeholder="Enter MSME registration number"
                      {...register("msme_registration_number", {
                        required: "Please Enter MSME number",
                      })}
                      error={Boolean(errors?.msme_registration_number)}
                      helperText={errors?.msme_registration_number?.message}
                      onChange={(e) => {
                        setMsmenum(e.target.value);
                        setValue("msme_registration_number", e.target.value, { shouldValidate: true });
                        setCheckedMSME(false);
                        setMsmeMismatch(null);
                      }}
                    />
                  )}
                  {msmeLoading && (
                    <div style={{ marginTop: "5px" }}>
                      <span style={{ fontSize: "13px", color: "var(--button-color, #4945FF)", fontStyle: "italic" }}>
                        Fetching details from Government portal...
                      </span>
                    </div>
                  )}
                  {/* Validate button - Skip for Proprietary Firm */}
                  {userdata.msme_register === "others" &&
                    mSME !== "others" &&
                    mSME !== "" && (
                      <div
                        style={{
                          marginTop: "10px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          gap: "10px",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <LoadingButton
                            loading={msmeLoading}
                            variant="contained"
                            size="small"
                            onClick={validateMsme}
                            sx={{
                              background: checkedMSME ? "#2e7d32" : "#4059e5",
                              textTransform: "none",
                              fontFamily: "var(--font-family-reg)",
                              fontSize: "13px",
                              "&:hover": {
                                background: checkedMSME ? "#1b5e20" : "#3347c4",
                              },
                            }}
                          >
                            {checkedMSME ? "Validated ✓" : "Validate"}
                          </LoadingButton>
                          {checkedMSME && (
                            <CheckCircleIcon
                              sx={{ color: "#2e7d32", fontSize: "20px" }}
                            />
                          )}
                        </div>
                      </div>
                    )}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.msme)}
                >
                  <VendorCardLabel>
                    Upload MSME Document<Super>*</Super>
                  </VendorCardLabel>
                  {msmeDoc !== "" ? (
                    <>
                      <span
                        style={{
                          color: "#4945FF",
                          fontSize: "13px",
                          fontFamily: "var(--font-family-reg)",
                        }}
                      >
                        <a
                          href={
                            msmeDoc instanceof File
                              ? URL.createObjectURL(msmeDoc)
                              : userdata?.msme_doc
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                              cursor: "pointer",
                            }}
                            label={msmeDoc.name || "MSME Document"}
                            value={msmeDoc.name || "MSME Document"}
                            name="chips"
                          />
                        </a>
                        <HighlightOffIcon
                          sx={{ color: "#4945FF", paddingBottom: "2px", cursor: "pointer" }}
                          fontSize="medium"
                          onClick={(e) => setmsmeDoc("")}
                        />
                      </span>
                    </>
                  ) : (
                    <label htmlFor="msme">
                      <Input
                        {...register("msme", {
                          required: "Please upload MSME Document",
                        })}
                        accept="*"
                        id="msme"
                        onChange={(e) => setmsmeDoc(e.target.files[0])}
                        type="file"
                      />
                      <StyledOutlineButton
                        variant="outlined"
                        component="span"
                      >
                        Upload
                      </StyledOutlineButton>
                    </label>
                  )}
                  {msmeDoc === "" ? (
                    <FormHelperText>{errors.msme?.message}</FormHelperText>
                  ) : (
                    ""
                  )}
                </FormControl>
              </Grid>
            </>
          ) : (
            ""
          )}
          {msmeMismatch && (
            <Grid item xs={12}>
              <Box
                sx={{
                  mt: 0,
                  p: 2,
                  border: "1px solid #FFDAD6",
                  borderRadius: "8px",
                  backgroundColor: "#FFECE9",
                  color: "#410002",
                }}
              >
                <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                  <InfoIcon sx={{ color: "#BA1A1A" }} />
                  <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#BA1A1A" }}>
                    Company Name Mismatch
                  </Typography>
                </Stack>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  There is a mismatch between the MSME Certificate name and the PAN Card Legal Name.
                </Typography>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="caption" sx={{ display: "block", color: "#534341", fontWeight: "bold" }}>
                      PAN Card Legal Name
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {msmeMismatch.legalName}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="caption" sx={{ display: "block", color: "#534341", fontWeight: "bold" }}>
                      MSME Enterprise Name
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {msmeMismatch.enterpriseName}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          )}
        </Grid>
        <br />

        {(userdata.msme_type !== "others" || validatedMsmeData) ? (
          <>
            <MsmeComponents
              msme_type={
                validatedMsmeData
                  ? validatedMsmeData.msme_type
                  : userdata?.msme_type
              }
              enterprise_name={
                validatedMsmeData
                  ? validatedMsmeData.enterprise_name
                  : userdata?.enterprise_name
              }
              enterprise_activity={
                validatedMsmeData
                  ? validatedMsmeData.enterprise_activity
                  : userdata?.enterprise_activity
              }
              classification_date={
                validatedMsmeData
                  ? validatedMsmeData.classification_date
                  : userdata?.classification_date
              }
              classification_year={
                validatedMsmeData
                  ? validatedMsmeData.classification_year
                  : userdata?.classification_year
              }
            />

          </>
        ) : (
          ""
        )}
      </Container>
    </CardContent>
  );

  const documents = (
    <CardContent>
      <Container fixed>
        <VendorCardTitle style={{ marginBottom: "3px" }}>
          Documents
        </VendorCardTitle>
        <VRSubTitle>
          <span>
            <img src={info} alt="icon" />
          </span>
          {"\u00A0"}
          {"\u00A0"}
          TDS may be deducted at higher rates in case of incorrect or missing
          PAN information as per IT rules
        </VRSubTitle>
        {is_domestic === true && (
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            style={{ marginTop: "10px" }}
          >
            <Grid item xs={6}>
              <span
                variant="outlined"
                component="span"
                style={{ width: "50%" }}
              >
                <DocumentLabels>
                  Upload PAN copy<Super>*</Super>
                </DocumentLabels>
              </span>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                style={{ width: "100%" }}
                error={Boolean(errors?.pan)}
              >
                {panDoc !== "" ? (
                  <>
                    <span
                      style={{
                        color: "#4945FF",
                        fontSize: "13px",
                        fontFamily: "var(--font-family-reg)",
                      }}
                    >
                      <a
                        href={`${vendor_details.Documents?.[0]?.pan_image}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Chip
                          style={{
                            width: "150px",
                            color: "#4945FF",
                            margin: "5px",
                            borderRadius: "5px",
                            border: "1px solid #D9D8FF",
                            background: "#F0F0FF",
                          }}
                          label={panDoc.name}
                          value={panDoc.name}
                          name="chips"
                        />
                      </a>
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={(e) => setPanDoc("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="pan">
                    <Input
                      {...register("pan", {
                        required: "Please upload PAN copy",
                      })}
                      accept="*"
                      id="pan"
                      onChange={(e) => setPanDoc(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
                {panDoc === "" ? (
                  <FormHelperText>{errors.pan?.message}</FormHelperText>
                ) : (
                  ""
                )}
              </FormControl>
            </Grid>
          </Grid>
        )}

        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          style={{ marginTop: "10px" }}
        >
          <Grid item xs={6}>
            <span variant="outlined" component="span" style={{ width: "50%" }}>
              <DocumentLabels>
                <>
                  {vendorCompany?.id === 3 ? "VAD" : "Vendor information form"}
                  {vendorCompany?.id === 1 || vendorCompany?.id === 5 ? (
                    ""
                  ) : (
                    <Super>*</Super>
                  )}
                </>
              </DocumentLabels>
              {vendorCompany.id === 2 ? (
                <CustomDocumentLink
                  style={{ fontSize: "0.8rem" }}
                  href={VRF_vishakha}
                >
                  <FileDownload fontSize="small" color="primary" />
                  {"\u00A0"} Download Form
                </CustomDocumentLink>
              ) : (
                ""
              )}
            </span>
          </Grid>
          <Grid item xs={6}>
            <FormControl
              variant="standard"
              style={{ width: "100%" }}
              error={Boolean(errors?.dealerName)}
            >
              {dealer !== "" ? (
                <>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(--font-family-reg)",
                    }}
                  >
                    <a
                      href={`${vendor_details.Documents?.[0].dealer_authorization_image}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={dealer.name}
                        value={dealer.name}
                        name="chips"
                      />
                    </a>
                    <HighlightOffIcon
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={(e) => setDealer("")}
                    />
                  </span>
                </>
              ) : (
                <label htmlFor="dealer">
                  <Input
                    {...register("dealerName", {
                      required:
                        vendorCompany?.id === 1 || vendorCompany?.id === 5
                          ? false
                          : "Please upload vendor form copy",
                    })}
                    accept="*"
                    id="dealer"
                    name="dealer"
                    onChange={(e) => setDealer(e.target.files[0])}
                    type="file"
                  />

                  <StyledOutlineButton variant="outlined" component="span">
                    Upload
                  </StyledOutlineButton>
                  <span>{dealer.name}</span>
                </label>
              )}
              {dealer === "" ? (
                <FormHelperText>{errors.dealerName?.message}</FormHelperText>
              ) : (
                ""
              )}
            </FormControl>
          </Grid>
        </Grid>

        {vendorCompany?.id !== 2 && (
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            style={{ marginTop: "10px" }}
          >
            <Grid item xs={6}>
              <span
                variant="outlined"
                component="span"
                style={{ width: "50%" }}
              >
                <DocumentLabels> Upload TIN certificate</DocumentLabels>
              </span>
            </Grid>
            <Grid item xs={6}>
              {tin !== "" ? (
                <>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(--font-family-reg)",
                    }}
                  >
                    <a
                      href={`${vendor_details.Documents?.[0].tin_certificate_image}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={tin.name}
                        value={tin.name}
                        name="chips"
                      />
                    </a>
                    <HighlightOffIcon
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={(e) => setTin("")}
                    />
                  </span>
                </>
              ) : (
                <label htmlFor="tin_doc">
                  <Input
                    accept="*"
                    id="tin_doc"
                    name="tin_doc"
                    onChange={(e) => setTin(e.target.files[0])}
                    type="file"
                  />
                  <StyledOutlineButton variant="outlined" component="span">
                    Upload
                  </StyledOutlineButton>
                  <span>{tin.name}</span>
                </label>
              )}
            </Grid>
          </Grid>
        )}

        {vendorCompany?.id !== 2 && (
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            style={{ marginTop: "10px" }}
          >
            <Grid item xs={6}>
              <span
                variant="outlined"
                component="span"
                style={{ width: "50%" }}
              >
                <DocumentLabels>
                  Upload ISO, RSDO and any additional certificate
                </DocumentLabels>
              </span>
            </Grid>
            <Grid item xs={6}>
              {iso !== "" ? (
                <>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(--font-family-reg)",
                    }}
                  >
                    <a
                      href={`${vendor_details.Documents?.[0].iso_or_rsdo_or_any_image}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={iso.name}
                        value={iso.name}
                        name="chips"
                      />
                    </a>
                    <HighlightOffIcon
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={(e) => setIso("")}
                    />
                  </span>
                </>
              ) : (
                <label htmlFor="iso_doc">
                  <Input
                    accept="*"
                    id="iso_doc"
                    name="iso_doc"
                    onChange={(e) => setIso(e.target.files[0])}
                    type="file"
                  />
                  <StyledOutlineButton variant="outlined" component="span">
                    Upload
                  </StyledOutlineButton>
                  <span>{iso.name}</span>
                </label>
              )}
            </Grid>
          </Grid>
        )}

        {newDocs.map((item, index) => (
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            key={index}
            style={{ marginTop: "10px" }}
          >
            <Grid item xs={6}>
              <span
                variant="outlined"
                component="span"
                style={{ width: "50%" }}
              >
                <DocumentLabels style={{ marginTop: "10px" }}>
                  {index === 0 ? "Upload Any Documents" : ""}
                </DocumentLabels>
              </span>
            </Grid>
            {anyDocs[index] && anyDocs[index] !== "" ? (
              <Grid item xs={6}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(--font-family-reg)",
                    }}
                  >
                    <a
                      href={`${anyDocs[index].path ? anyDocs[index].path : ""}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={anyDocs[index].name}
                        value={anyDocs[index].name}
                        name="chips"
                      />
                    </a>
                    <HighlightOffIcon
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={(e) => handleclearDoc(e, index)}
                    />
                  </span>
                </FormControl>
              </Grid>
            ) : (
              <>
                <Grid item xs={3}>
                  <FormControl variant="standard" style={{ width: "100%" }}>
                    <label>
                      <Input
                        accept="*"
                        id={`anyDocs${index}`}
                        onChange={(e) => handlechangeDoc(e, index)}
                        type="file"
                      />
                      <StyledOutlineButton
                        variant="outlined"
                        component="span"
                      >
                        Upload
                      </StyledOutlineButton>
                    </label>
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  {index > 0 ? (
                    <CustomButton
                      className="invoiceErrbutn"
                      color="error"
                      variant="outlined"
                      size="small"
                      onClick={(e) => handleRemove(e, index)}
                      style={{ marginTop: "10px " }}
                    >
                      Remove
                    </CustomButton>
                  ) : (
                    ""
                  )}
                </Grid>
              </>
            )}
          </Grid>
        ))}

        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          style={{ marginTop: "10px" }}
        >
          <Grid item xs={6}></Grid>
          <Grid item xs={6}>
            <CustomButton
              size="small"
              color="primary"
              variant="outlined"
              onClick={handleOnClick}
              className="invoiceErrbutn"
            >
              Add Document
            </CustomButton>
          </Grid>
        </Grid>
      </Container>
    </CardContent>
  );
  const additional_info = (
    <CardContent>
      <Container fixed>
        <VendorCardTitle>Additional information</VendorCardTitle>
        <Grid container spacing={1}>
          <Grid item xs={6} sm={6} md={9}>
            <VRSubTitle>
              Areas of business interest. Select all that apply and wait for the
              HSN/SAC code to appear below
            </VRSubTitle>
          </Grid>
          <Grid item xs={6} sm={6} md={3}>
            <VRSubTitle style={{ textAlign: "right" }}>
              <a
                rel="noopener noreferrer"
                href={`${vendorCompany?.domain_url}/api/hsn_codes`}
                style={{
                  textDecoration: "none",
                  whiteSpace: "nowrap",
                  color: "#4059e5",
                }}
                target="_blank"
              >
                Download Codesheet
              </a>
            </VRSubTitle>
          </Grid>
        </Grid>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item md={3} xs={12}>
            <AdditionalDetailsCard>
              <CardContent style={{ overflow: "auto", height: "272px" }}>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                // style={{ marginTop: "36px" }}
                >
                  <Grid
                    style={checkedType === "2" ? radioStyles.selectRadio : null}
                  >
                    <CustomFormSelection
                      value="2"
                      control={<Radio style={{ visibility: "hidden" }} />}
                      label="Goods"
                      style={{
                        textAlign: "-23px",
                      }}
                      onChange={(e) => handleadditionalChange(e, "2")}
                      className="goods"
                    />

                    {checkedType === "2" ? (
                      <ArrowRightIcon
                        style={{
                          textAlign: "center",
                          float: "right",
                          marginTop: "7px",
                          marginLeft: "-32px",
                        }}
                      />
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid
                    style={checkedType === "1" ? radioStyles.selectRadio : null}
                  >
                    <CustomFormSelection
                      value="1"
                      control={<Radio style={{ visibility: "hidden" }} />}
                      label="Services"
                      /*  style={{ textAlign: "-25px" }} */
                      onChange={(e) => handleadditionalChange(e, "1")}
                      className="goods"
                    />
                    <span
                      style={{
                        textAlign: "center",
                        float: "right",
                        marginTop: "7px",
                        marginLeft: "-32px",
                      }}
                    >
                      {checkedType === "1" ? <ArrowRightIcon /> : ""}
                    </span>
                  </Grid>
                </RadioGroup>
              </CardContent>
            </AdditionalDetailsCard>
          </Grid>
          {isLoading ? (
            <Grid item md={3} xs={12}>
              <AdditionalDetailsCard>
                <CardContent style={{ overflow: "auto", height: "272px" }}>
                  <Skeleton count={7} />
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : code_filtered ? (
            <Grid item md={3} xs={12} style={{ display: catdisplay }}>
              <AdditionalDetailsCard>
                <div style={{ height: "50px", backgroundColor: " #F7F9FC" }}>
                  <TextField
                    id="Search"
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon fontSize="small" />
                        </IconButton>
                      ),
                    }}
                    className="search_for_add_info"
                    variant="standard"
                    onChange={(e) => handleSearchChange(e)}
                    placeholder="Search by description"
                  />
                </div>
                <CardContent
                  style={{
                    paddingTop: "5px",
                    overflow: "auto",
                    height: "222px",
                  }}
                >
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                  >
                    {code_filtered.length ? (
                      code_filtered.map((item, index) => (
                        <Grid
                          key={index}
                          style={
                            subCategory === `${item.category}`
                              ? radioStyles1.selectRadio
                              : null
                          }
                        >
                          <Tooltip
                            title={item.categortDescription}
                            placement="right"
                          >
                            <CustomFormControl
                              style={{
                                fontSize: "12px",
                              }}
                              label={item.categortDescription}
                              value={item.category}
                              control={
                                <Radio style={{ visibility: "hidden" }} />
                              }
                              onChange={(e) =>
                                handlecategoryChange(e, `${item.category}`)
                              }
                              className="goods1"
                            />
                          </Tooltip>
                        </Grid>
                      ))
                    ) : (
                      <VendorCardLabel>
                        <br />
                        <InfoIcon
                          sx={{
                            fill: "grey",
                            height: "18px",
                            width: "18px",
                          }}
                        />
                        {"There are no categeories to display"}
                      </VendorCardLabel>
                    )}
                  </RadioGroup>
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : (
            ""
          )}

          {isLoadingsub ? (
            <Grid item md={3} xs={12}>
              <AdditionalDetailsCard>
                <CardContent style={{ overflow: "auto", height: "272px" }}>
                  <Skeleton count={7} />
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : sub_filtered ? (
            <Grid item md={3} xs={12} style={{ display: subcatdisplay }}>
              <AdditionalDetailsCard>
                <div style={{ height: "50px", backgroundColor: " #F7F9FC" }}>
                  <TextField
                    id="Search"
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon fontSize="small" />
                        </IconButton>
                      ),
                    }}
                    className="search_for_add_info"
                    variant="standard"
                    onChange={(e) => setSearchsub(e.target.value)}
                    style={{ fontSize: "12px !important" }}
                    placeholder="Search by code"
                  />
                </div>
                <CardContent
                  style={{
                    paddingTop: "5px",
                    overflow: "auto",
                    height: "222px",
                  }}
                >
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                  >
                    {sub_filtered.length ? (
                      sub_filtered.map((item, index) => (
                        <Grid
                          key={index}
                          style={
                            itemcodes === `${item.subCategory}`
                              ? radioStyles1.selectRadio
                              : null
                          }
                        >
                          <Tooltip
                            title={item.subCategoryDescription}
                            placement="right"
                          >
                            <CustomFormControl
                              style={{
                                fontSize: "12px",
                              }}
                              label={
                                item.subCategory +
                                " - " +
                                item.subCategoryDescription
                              }
                              value={item.subCategory}
                              control={
                                <Radio style={{ visibility: "hidden" }} />
                              }
                              onChange={(e) =>
                                handlesubcategoryChange(
                                  e,
                                  `${item.subCategory}`
                                )
                              }
                              className="goods1"
                            />
                          </Tooltip>
                        </Grid>
                      ))
                    ) : (
                      <VendorCardLabel>
                        <br />
                        <InfoIcon
                          sx={{
                            fill: "grey",
                            height: "18px",
                            width: "18px",
                          }}
                        />
                        {"There are no categeories to display"}
                      </VendorCardLabel>
                    )}
                  </RadioGroup>
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : (
            ""
          )}

          {isLoadingitem ? (
            <Grid item md={3} xs={12}>
              <AdditionalDetailsCard>
                <CardContent style={{ overflow: "auto", height: "272px" }}>
                  <Skeleton count={7} />
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : item_filtered ? (
            <Grid item md={3} xs={12} style={{ display: itemcatdisplay }}>
              <AdditionalDetailsCard>
                <div style={{ height: "50px", backgroundColor: " #F7F9FC" }}>
                  <TextField
                    id="Search"
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon fontSize="small" />
                        </IconButton>
                      ),
                    }}
                    className="search_for_add_info"
                    variant="standard"
                    onChange={(e) => setSearchitem(e.target.value)}
                    style={{ fontSize: "12px !important" }}
                    placeholder="Search by code"
                  />
                </div>
                <CardContent
                  style={{
                    paddingTop: "5px",
                    overflow: "auto",
                    height: "222px",
                  }}
                >
                  {item_filtered.length ? (
                    item_filtered.map((item, index) => (
                      <FormGroup
                        key={item.id}
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                      >
                        <Grid key={item.id}>
                          <Tooltip
                            title={item.itemDescription}
                            placement="bottom"
                          >
                            <CustomFormControl
                              multiple
                              key={item.id}
                              style={{ fontSize: "12px" }}
                              value={item.item}
                              control={
                                <Checkbox
                                  sx={{
                                    color: "lightgray",
                                    "&.Mui-checked": {
                                      color: "#4059e5",
                                    },
                                  }}
                                  checked={personName.includes(`${item.item}`)}
                                />
                              }
                              label={item.item + " - " + item.itemDescription}
                              className="itemName"
                              onChange={(e) =>
                                handleCheckChange(e, `${item.item}`)
                              }
                            />
                          </Tooltip>
                        </Grid>
                      </FormGroup>
                    ))
                  ) : (
                    <VendorCardLabel>
                      <br />
                      <InfoIcon
                        sx={{
                          fill: "grey",
                          height: "18px",
                          width: "18px",
                        }}
                      />
                      {"There are no sub categeories to display"}
                    </VendorCardLabel>
                  )}
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
        <br />
        <VendorCardTitle style={{ paddingBottom: "0px" }}>
          Selected HSN/SAC Codes
        </VendorCardTitle>
        <FormControl>
          <Stack direction="row" spacing={4}>
            <Grid item xs={2}>
              <VendorCardBlankTitle
                style={{ marginTop: "0", marginBottom: "10px" }}
              >
                {userinfo.codes.length ? "" : "No codes selected."}
              </VendorCardBlankTitle>

              {userinfo.codes.map((item, index) =>
                item !== "null" ? (
                  <Chip
                    key={index}
                    style={{
                      color: "#4945FF",
                      margin: "0 5px 10px 0 ",
                      borderRadius: "5px",
                      border: "1px solid #D9D8FF",
                      background: "#F0F0FF",
                    }}
                    label={item}
                    value={item}
                    name="chips"
                    onDelete={handleDelete(item)}
                    deleteIcon={
                      <Clear sx={{ height: "18px", width: "18px" }} />
                    }
                  />
                ) : (
                  ""
                )
              )}
            </Grid>
          </Stack>
        </FormControl>
        <Grid>
          <VendorCardLabel>Additional business areas</VendorCardLabel>
          <TextField
            sx={{
              input: { fontSize: "14px", fontFamily: "var(--font-family-reg)" },
            }}
            id="business_interest_areas"
            placeholder="Enter interest areas"
            variant="standard"
            style={{ width: "100%" }}
            name="business_interest_areas"
            value={userdata.business_interest_areas || ""}
            {...register("business_interest_areas", {
              required: false,
              value: userdata.business_interest_areas,
            })}
            onChange={(e) => onChange(e)}
          />
        </Grid>
        <br />
        {is_domestic === true ? (
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  color: "lightgray",
                  "&.Mui-checked": {
                    color: "#4059e5",
                  },
                }}
                onChange={handleChange}
                name="pan_declaration"
                checked={checkedPan}
              />
            }
            label={
              <CheckBoxLabel>
                I confirm that the PAN I entered above should be used for all
                TDS deductions made for our company payments
              </CheckBoxLabel>
            }
          />
        ) : (
          ""
        )}
      </Container>
    </CardContent>
  );

  // useEffect(()=>{
  //   ViewVendordetails();
  // },[]);

  if (isDetailsLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Stepper activeStep={activeStep}>
          <div className="stepsDiv">
            {steps.map((label, index) => {
              const stepProps = {};

              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }

              // determine status based on activeStep
              const isCurrent = index === activeStep;
              const isCompleted = index < activeStep;
              let statusClass;
              if (isCompleted) {
                // completed steps use green style
                statusClass = "fstone_1";
              } else if (isCurrent) {
                // current step uses orange
                statusClass = "fstone";
              } else {
                statusClass = "secone";
              }

              return (
                <div
                  key={index}
                  className={`stepcolm ${statusClass} ${isCurrent ? "activeStep" : ""
                    }`}
                  style={{ zIndex: steps.length - index }}
                >
                  <div>
                    {index < activeStep ? (
                      <CheckCircleIcon className="checkedCircle" />
                    ) : (
                      <span>{`${index + 1}. `}</span>
                    )}
                    {label}
                  </div>
                </div>
              );
            })}
          </div>
        </Stepper>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Typography sx={{ mt: 2, mb: 1 }}>
              All steps completed - you&apos;re finished
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button onClick={handleReset}>Reset</Button>
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {/* <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography> */}
            <br />
            {activeStep === 0 ? (
              <>
                <form
                  onSubmit={handleSubmit(handleNext)}
                  encType="multipart/form-data"
                >
                  <StyledCard>{card}</StyledCard>
                  <StyledCard>{statutory_information}</StyledCard>

                  {is_domestic && <StyledCard>{msme_information}</StyledCard>}

                  <StyledCard>{documents}</StyledCard>

                  <StyledCard>{additional_info}</StyledCard>

                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                    <Button
                      color="inherit"
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      sx={{ mr: 1, display: "none" }}
                    >
                      Back
                    </Button>

                    <Box sx={{ flex: "1 1 auto" }} />
                    <LoadingButton
                      sx={{
                        textTransform: "none",
                        background: "var(--button-color)",
                        width: "200px",
                        height: "40px",
                      }}
                      color="success"
                      variant="contained"
                      disabled={
                        is_domestic !== true
                          ? false
                          : checkedPan === false
                            ? true
                            : false
                      }
                      type="submit"
                      loading={loading}
                      loadingPosition="start"
                    >
                      Save & Next
                    </LoadingButton>
                  </Box>
                </form>
              </>
            ) : activeStep === 1 ? (
              <>
                {!vendor_details?.Locations?.length && vendorCompany?.id === 2 ? (
                  <BankReg
                    activeStep={activeStep}
                    handleBack={handleBack}
                    checkedPan={checkedPan}
                    steps={steps}
                    registrationtype={vendor_details?.gst_registration_type}
                    clientId={vendorCompany?.id}
                    is_domestic={is_domestic}
                    setActiveStep={setActiveStep}
                    setSkipped={setSkipped}
                    isStepSkipped={isStepSkipped}
                    skipped={skipped}
                    isApproved={isApproved}
                  />
                ) : (
                  <BankRegEdit
                    activeStep={activeStep}
                    handleBack={handleBack}
                    checkedPan={checkedPan}
                    steps={steps}
                    vendor_details={vendor_details}
                    clientId={vendorCompany?.id}
                    is_domestic={is_domestic}
                    setActiveStep={setActiveStep}
                    setSkipped={setSkipped}
                    isStepSkipped={isStepSkipped}
                    skipped={skipped}
                    isApproved={isApproved}
                  />
                )}
              </>
            ) : (
              <BankDetailsManager
                activeStep={activeStep}
                handleBack={handleBack}
                user_id={vendor_details?.user_id}
                vendor_id={vendor_id || vendor_details?.id}
                is_domestic={is_domestic}
                company_id={vendorCompany?.id}
                setSkipped={setSkipped}
                setActiveStep={setActiveStep}
                isStepSkipped={isStepSkipped}
                skipped={skipped}
                isLocked={
                  vendor_details?.is_pending === true &&
                  vendor_details?.status !== "Saved as Draft"
                }
              />
            )}
          </React.Fragment>
        )}
      </Box>
      {/* dialog  box*/}
      <Dialog open={editMSMEDailog} onClose={msmeEditCancleHandle} fullWidth maxWidth="sm">
        <DialogTitle style={{ cursor: "move", fontWeight: "Bold" }}>
          Edit MSME Details
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Grid item xs={12} md={4}>
              <FormControl variant="standard" style={{ width: "100%" }}>
                <VendorCardLabel>
                  MSME registration number <Super>*</Super>
                </VendorCardLabel>
                <TextField
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  InputProps={{
                    disableUnderline: false,
                    disableInjectingGlobalStyles: true,
                  }}
                  InputLabelProps={{
                    disableAnimation: true,
                    disableInjectingGlobalStyles: true,
                  }}
                  size="small"
                  variant="standard"
                  style={{
                    width: "100%",
                    paddingTop: "3px",
                    borderBottom: "1px solid lightgray",
                  }}
                  name="msme_registration_number_edit"
                  placeholder="Enter MSME registration number"
                  {...register("msme_registration_number_edit", {
                    required: editMSMEDailog
                      ? "please enter msme number"
                      : false,
                    pattern: {
                      value: /^UDYAM-[A-Z]{2}-[0-9]{2}-[0-9]{7}$/i,
                      message:
                        "Invalid MSME/Udyam number (Format: UDYAM-XX-00-0000000)",
                    },
                  })}
                  value={editMSMENumber || ""}
                  onChange={(e) => {
                    setEditMSMENumber(e.target.value);
                    setCheckedMSME(false);
                  }}
                  error={Boolean(errors?.msme_registration_number_edit)}
                  helperText={errors?.msme_registration_number_edit?.message}
                />
                {msmeLoading && (
                  <div style={{ marginTop: "5px" }}>
                    <span style={{ fontSize: "13px", color: "var(--button-color, #4945FF)", fontStyle: "italic" }}>
                      Fetching details from Government portal...
                    </span>
                  </div>
                )}
              </FormControl>
            </Grid>

          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ alignItems: "right" }}>
          <Button onClick={msmeEditCancleHandle}>cancel</Button>
          <LoadingButton
            loading={msmeLoading}
            variant="contained"
            size="small"
            onClick={() => {
              if (!watch("company_constitution") && !userdata?.company_constitution) {
                return message.error("Please select Company constitution first");
              }
              if (!editMSMENumber)
                return message.info("Please enter MSME Registration Number");
              dispatch(
                validateMSMENumber({
                  msme: editMSMENumber,
                  company_constitution: userdata?.company_constitution || watch("company_constitution") || "",
                  legal_name: value?.legal_name || "",
                  user_id: value?.user_id || value?.id || undefined,
                })
              ).then((response) => {
                const { success, data, message: msg } = response.payload;
                if (
                  success &&
                  data?.[0]?.status === "completed" &&
                  data?.[0]?.result?.source_output?.status === "id_found"
                ) {
                  const generalDetails =
                    data[0]?.result?.source_output?.general_details;
                  const enterpriseTypeData =
                    data[0]?.result?.source_output?.enterprise_type?.[0]
                      ?.enterprise_type_1;
                  setValidatedMsmeData({
                    msme_registration_number: editMSMENumber || "",
                    msme_type: generalDetails?.enterprise_type || "",
                    enterprise_name:
                      generalDetails?.enterprise_name ||
                      value?.legal_name ||
                      "",
                    enterprise_activity: generalDetails?.major_activity || "",
                    classification_date:
                      enterpriseTypeData?.classification_date || "",
                    classification_year:
                      enterpriseTypeData?.classification_year || "",
                  });
                  setCheckedMSME(true);
                  setMsmeMismatch(null);
                  setEditMSMEDailog(false);
                } else {
                  setCheckedMSME(false);
                  if (!success && msg === "Company name Mismatch between MSME Certificate & PAN Card.") {
                    const enterpriseName = data?.[0]?.result?.source_output?.general_details?.enterprise_name || "";
                    setMsmeMismatch({
                      legalName: value?.legal_name || "",
                      enterpriseName: enterpriseName,
                    });
                    setEditMSMEDailog(false);
                  } else {
                    setMsmeMismatch(null);
                  }
                }
              });
            }}
            sx={{
              background: checkedMSME ? "#2e7d32" : "#4059e5",
              textTransform: "none",
              fontFamily: "var(--font-family-reg)",
              fontSize: "13px",
              "&:hover": {
                background: checkedMSME ? "#1b5e20" : "#3347c4",
              },
            }}
          >
            {checkedMSME ? "Validated ✓" : "Validate"}
          </LoadingButton>
          {checkedMSME && (
            <CheckCircleIcon
              sx={{ color: "#2e7d32", fontSize: "20px", mr: 1 }}
            />
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}

export const StyledCard = materialStyles(Card)`
box-shadow: 0px 0px 20px rgba(127, 161, 250, 0.15);
flex-direction: column;
border: none;
width: 100%;
height: auto;
border-radius: 10px;
margin-bottom: 1em;
`;

export const VendorCardLabel = styled.div`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #32324d;
`;

export const VendorDisabledFields = styled.div`
  font-family: var(--font-family-semi-bold);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #212134;
`;

export const VendorLabelHolder = styled.div`
  text-align: left;
`;

export const StyledOutlineButton = materialStyles(Button)`
  border: 1px solid var(--button-color);
  color: black;
  height: 40px;
  padding: 8px 30px;
`;

export const StyledFilledButton = materialStyles(Button)`
  background: #1CB697;
  color: #fff;
  height: 40px;
  padding: 8px 30px;
`;

export const AdditionalDetailsCard = materialStyles(Card)`
border: 1px solid #D9D8FF;
background: #F7F9FC;
box-shadow: none;
`;

export const VRSubTitle = styled.div`
  margin-top: -15px;
  margin-bottom: 20px;
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  /* identical to box height, or 150% */

  /* Neutral/600 */

  color: #666687;
`;

export const DocumentLabels = styled.div`
  //styleName: 14/Medium;
  font-family: var(--font-family-med);
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
`;

export const CheckBoxLabel = styled.div`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Neutral/900 */

  color: #212134;
`;

export const StyledStep = materialStyles(Step)`
box-shadow: 0px 0px 20px rgba(127, 161, 250, 0.15);
flex-direction: column;
border: none;
width: 100%;
height: auto;
border-radius: 10px;
margin-bottom: 1em;
`;

export const CustomButton = materialStyles(Button)`
 ::hover{
   background-color: #1cb;
   font-size: 16.5px;
   transition: all 0.3ms ease-in;
 }
`;

export const SelectSpan = styled.span`
  font-family: var(--font-family-reg);
  font-size: 14px;
  color: "black";
`;

export const StepsSpan = styled.span`
  font-family: var(--font-family-reg);
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  padding-right: 10px;
  color: #4a4a6a;
`;
